/**
 * MotionX frontend runtime configuration.
 *
 * Set in `.env`:
 *   SERVER_URL=http://your-server:8000
 *
 * WebSocket (/ws) and REST API (/api) are derived automatically.
 */

const DEFAULT_SERVER_URL = 'http://localhost:8000';

function stripTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '');
}

function deriveWsUrl(serverUrl: string): string {
  const url = new URL(serverUrl);
  const protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${url.host}/ws`;
}

function deriveApiUrl(serverUrl: string): string {
  return `${stripTrailingSlash(serverUrl)}/api`;
}

function parseServerHost(serverUrl: string): string {
  try {
    return new URL(serverUrl).host;
  } catch {
    return 'localhost:8000';
  }
}

const serverUrl = stripTrailingSlash(process.env.SERVER_URL ?? DEFAULT_SERVER_URL);

export const env = {
  serverUrl,
  serverHost: parseServerHost(serverUrl),
  wsUrl: process.env.WS_URL || deriveWsUrl(serverUrl),
  apiUrl: process.env.API_URL || deriveApiUrl(serverUrl),
} as const;
